import { clone } from 'lodash';
import Request from '@/core/QuRequest';

const req = new Request();

export default {
  methods: {
    // 获取权限组列表
    async getPermList() {
      try {
        const res = await req.send(req.Apis.sales.user.userPermList);
        if (res && res.code === 200) {
          this.data = res.data;
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    // 新增权限组
    async addPerm(data) {
      const _data = clone(data);
      try {
        const res = await req.send(req.Apis.sales.user.userPermAdd, data);
        if (res.code === 200 && res.data) {
          if (this.current) {
            const d = {
              ..._data,
              id: res.data.id,
            };
            this.current.children.push(d);
            this.$message.success('添加权限成功');
          } else {
            const d = {
              ..._data,
              id: res.data.id,
            };
            this.data.unshift(d);
          }
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    // 修改权限组
    async updatePerm(data) {
      const _data = clone(data);
      try {
        const res = await req.send(req.Apis.sales.user.userPermUpdate, data);
        if (res.code === 200 && res.data) {
          const current = this.current;
          Object.keys(_data).forEach((key) => {
            current[key] = _data[key];
          });
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    // 删除权限组
    async removePerm(data, node) {
      try {
        const res = await req.send(req.Apis.sales.user.userPermRemove, data);
        if (res.code === 200) {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex((d) => d.id === data.id);
          children.splice(index, 1);
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    // 获取当前权限组下的路由
    async getPermRouters(data) {
      try {
        const res = await req.send(
          req.Apis.sales.user.userPermGetRouters,
          data,
        );
        if (res.code === 200) {
          return res.data;
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    // 新增路由
    async addPermRouter(data) {
      try {
        const res = await req.send(
          req.Apis.sales.user.userPermAddRouters,
          data,
        );
        if (res.code === 200 && res.data) {
          const d = {
            ...data,
            id: res.data.id,
          };
          this.routers.data.push(d);
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    // 删除路由
    async removePermRouter(data) {
      try {
        const res = await req.send(
          req.Apis.sales.user.userPermRemoveRouters,
          data,
        );
        if (res.code === 200) {
          const index = this.routers.data.findIndex((d) => d.id === data.id);
          this.routers.data.splice(index, 1);
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
  },
};
